import React from "react";
import Router from "routes/Router";
import WithAuthentication from "Authentication/WithAuthentication.tsx";
import toast, { Toaster } from "react-hot-toast";
function App() {
  return (
    <div className="App">
      <Toaster />
      <WithAuthentication>
        <Router />
      </WithAuthentication>
    </div>
  );
}

export default App;
